const misc = {
  getTimeStr (halfHours) {
    const hh = halfHours % 48
    let str = hh < 20 ? '0' : ''
    str += (hh - hh % 2) / 2
    str += ':'
    str += hh % 2 === 0 ? '00' : '30'
    return str
  },

  getHalfHours (timeStr) {
    if (timeStr === '') {
      return null
    }
    const time = timeStr.split(':')
    return parseFloat(time[0]) * 2 + parseFloat(time[1]) / 30
  },

  isOSegmentValid (segment) {
    return (segment.start === 0 || segment.start > 0) && (segment.end === 0 || segment.end > 0)
  },

  isOSegmentWithValue (segment) {
    return (segment.start === 0 || segment.start > 0) || (segment.end === 0 || segment.end > 0)
  },

  deepCopy (obj) {
    // Assuming only variables and not any functions in object
    return JSON.parse(JSON.stringify(obj))
  },

  isObjectEqual (obj1, obj2, keys) {
    // Assuming only variables and not any functions in object
    if (!keys) {
      return JSON.stringify(obj1) === JSON.stringify(obj2)
    }

    for (let i = 0; i < keys.length; i++) {
      if (obj1[keys[i]] !== obj2[keys[i]]) {
        return false
      }
    }

    return true
  },

  objectValues (obj) {
    return Object.keys(obj).map(key => obj[key])
  },

  isRecordEmpty (record) {
    if (record.nTime ||
        misc.getOTime(record) > 0 ||
        record.note
       ) {
      return false
    }

    return true
  },

  genAllNotes (records) {
    const notes = []
    records.forEach(record => {
      if (record.note && !(notes.indexOf(record.note) >= 0)) {
        notes.push(record.note)
      }
    })
    return notes
  },

  findRecordIndex (targetRecord, records) {
    return records.findIndex(record => {
      if (targetRecord._id === record._id ||
          targetRecord.userId === record.userId &&
          targetRecord.projectId === record.projectId &&
          targetRecord.taskId === record.taskId &&
            targetRecord.dateString === record.dateString
      ) {
        return true
      }
      return false
    })
  },

  getMondayByMs (date) {
    let shiftDay = date.getDay() - 1 // shiftday to monday
    if (shiftDay < 0) {
      shiftDay += 7
    }
    const aDayInMs = 86400 * 1000
    date.setTime(date.getTime() - shiftDay * aDayInMs)
    let thisMonday = date
    thisMonday = {
      year: thisMonday.getFullYear(),
      month: thisMonday.getMonth() + 1,
      date: thisMonday.getDate(),
    }

    return thisMonday
  },

  dateStringToMs (dateString) {
    // year, month, day
    const ymd = dateString.split('-')
    return Date.UTC(ymd[0], ymd[1] - 1, ymd[2])
  },

  msToDateString (utcTime) {
    const day = new Date(utcTime)
    return `${day.getUTCFullYear()}-${day.getUTCMonth() + 1}-${day.getUTCDate()}`
  },

  getWeekDay (record) {
    const date = new Date()
    const ms = misc.dateStringToMs(record.dateString)
    date.setTime(ms)
    return date.getUTCDay()
  },

  getOTime (record) {
    let oTime = 0
    record.oSegments.forEach(seg => {
      oTime += (seg.end - seg.start)
    })
    return oTime
  },

  getTTime (record) {
    let tTime = 0
    if (!record.tSegments) return tTime
    record.tSegments.forEach(seg => {
      tTime += (seg.end - seg.start)
    })
    return tTime
  },

  getDateString (thisMonday, weekDay) {
    const thisMondayInMs = Date.UTC(thisMonday.year, thisMonday.month - 1, thisMonday.date)
    const aDayInMs = 86400 * 1000
    return misc.msToDateString(thisMondayInMs + aDayInMs * ((weekDay + 6) % 7))
  },

  getMonthString (thisMonday, weekDay) {
    const thisMondayInMs = Date.UTC(thisMonday.year, thisMonday.month - 1, thisMonday.date)
    const aDayInMs = 86400 * 1000
    const day = new Date(thisMondayInMs + aDayInMs * ((weekDay + 6) % 7))
    return `${day.getUTCMonth() + 1}/${day.getUTCDate()}`
  },

  getSunday (thisMonday) {
    const thisMondayInMs = Date.UTC(thisMonday.year, thisMonday.month - 1, thisMonday.date)
    const aDayInMs = 86400 * 1000
    const sundayDate = new Date()
    sundayDate.setTime(thisMondayInMs + aDayInMs * 6)
    const sunday = {}
    sunday.year = sundayDate.getUTCFullYear()
    sunday.month = sundayDate.getUTCMonth() + 1
    sunday.date = sundayDate.getUTCDate()
    return sunday
  },

  isMatchFilterStr (item, filterStr) {
    if (filterStr === '' || !item) {
      return false
    }

    // do the character subsequence search with filter string
    let loc = 0
    for (let i = 0; i < filterStr.length; i++) {
      const subItemStr = item.substring(loc)
      const filterChar = filterStr.substr(i, 1)
      const index = subItemStr.indexOf(filterChar)
      if (index >= 0) {
        loc += index + 1
        if (i === filterStr.length - 1) {
          return true
        }
      } else {
        return false
      }
    }

    return false
  },

  getFilteredItems (items, filterStr) {
    if (filterStr === '') {
      return []
    }

    const filteredItems = []
    items.forEach(item => {
      if (misc.isMatchFilterStr(item, filterStr)) {
        filteredItems.push(item)
      }
    })
    return filteredItems
  },

  getValidOSegments (recordData) {
    const oSegments = []
    recordData.oSegments.forEach(segment => {
      if (misc.isOSegmentValid(segment)) {
        oSegments.push(segment)
      }
    })

    return oSegments
  },

  getValidTSegments (recordData) {
    const tSegments = []
    recordData.tSegments.forEach(segment => {
      if (misc.isOSegmentValid(segment)) {
        tSegments.push(segment)
      }
    })

    return tSegments
  },

  isValidDateString (value) {
    // 2015-1-10 format
    const tmp = value.split('-')
    if (tmp.length !== 3 || !tmp.every(t => t !== '')) {
      return false
    }

    try {
      Date.UTC(tmp[0], tmp[1] - 1, tmp[2])
      return true
    } catch (e) {
      return false
    }
  },

  getValidDateString (date) {
    return misc.msToDateString(Date.parse(date))
  },

  getISODateString (dateString) {
    if (misc.isValidDateString(dateString)) {
      const tmp = dateString.split('-')
      const newDate = new Date()
      newDate.setTime(Date.UTC(tmp[0], tmp[1] - 1, tmp[2]))
      return newDate.toISOString()
    }
    return 0
  },

  isEmpty (obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false
      }
    }
    return true
  },

  getDict (array, key) {
    const dict = {}
    array.forEach(item => dict[item._id] = item[key])
    return dict
  },

  getValue (array, _id, key) {
    for (let i = 0; i < array.length; i++) {
      if (array[i]._id === _id) {
        return array[i][key]
      }
    }
    return undefined
  },

  getName (array, _id) {
    return misc.getValue(array, _id, 'name')
  },

  getShiftedMonday (monday, shift) {
    // do shifting
    const newDate = new Date(monday.year, monday.month - 1, monday.date)
    const aDayInMs = 86400 * 1000
    newDate.setTime(newDate.getTime() + aDayInMs * 7 * shift)
    return misc.getMondayByMs(newDate)
  },

  onError (err) {
    console.log(`Error ${err.stack}`)
  },

  // http://stackoverflow.com/a/33542499/2797799
  saveCSV (filename, data) {
    const blob = new Blob([data], { type: 'text/csv' })
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveBlob(blob, filename)
    } else {
      const elem = window.document.createElement('a')
      elem.href = window.URL.createObjectURL(blob)
      elem.download = filename
      document.body.appendChild(elem)
      elem.click()
      document.body.removeChild(elem)
    }
  },

  getDay (dateString) {
    const tmps = dateString.split('-')
    const year = parseInt(tmps[0], 10)
    const month = parseInt(tmps[1], 10)
    const date = parseInt(tmps[2], 10)
    return { year, month, date }
  },

}

export default misc



// WEBPACK FOOTER //
// ./src/app/utils/misc.js